<template>
  <div>
    <div class="title-and-input">
      <!-- 标题 -->
      <span class="title">{{ title }}</span>

      <el-link class="input-button-style"
               v-if="editer_visable_prop"
               @click="editorButtonClick"
               :underline="false"
               type="info"
               icon="el-icon-edit">编辑</el-link>
      <el-link class="input-button-style"
               v-if="save_visable_prop"
               @click="saveButtonClick"
               :underline="false"
               style="float: right"
               type="info"
               icon="el-icon-folder-checked">保存</el-link>
    </div>
    <!-- 内容展示 -->
    <span>
      <div v-if="show_content_visable_prop"
           class="edito_save_right"
           @click="pastContent($event)"
           v-html="show_content"></div>
      <!-- 编辑器 -->
      <div class="input">
        <!-- 输入框 -->
        <el-input v-if="show_input_prop"
                  :class="{ class_name_one: false, class_name_two: true }"
                  size="mini"
                  v-model="input_text"
                  placeholder="请输入内容"></el-input>
      </div>
    </span>
  </div>
</template>

<script>
export default {
  name: 'input-modify',
  data() {
    return {
      info: '',
      is_editor: '',
      editer_visable_prop: this.edit_visable,
      save_visable_prop: this.save_visable,
      show_input_prop: this.show_editor,
      show_content_visable_prop: this.show_content_visable,
      // 输入组件
      input_textarea_width: '300px',
      input_text: this.show_content,
      input_textares: '',
      content: this.show_content,
      editor_content: '', //编辑器内容
    }
  },
  props: {
    title: String,
    show_content: String, //动态绑定显示的内容
    attribuite: Number,
    // 样式
    // input_width: String,
    type: String,
    edit_visable: {
      type: Boolean,
      default: true,
    },
    save_visable: {
      type: Boolean,
      default: false,
    },
    show_editor: {
      type: Boolean,
      default: false,
    },
    show_content_visable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    // 复制文本信息pastContent
    pastContent(event) {
      // console.log(event.target.innerHTML);
      this.$copyText(event.target.innerHTML).then((res) => {
        this.$message({
          message: '信息已复制到剪贴板',
          type: 'success',
        })
      })
    },

    // 编辑时的 方法
    editorButtonClick() {
      this.save_visable_prop = true
      this.editer_visable_prop = false
      this.show_input_prop = true
      this.show_content_visable_prop = false
      this.editor_content = this.show_content
      //   console.log("编辑" + this.editor_content);
      //   this.$emit("change",this.)
    },
    saveButtonClick() {
      this.save_visable_prop = false
      this.editer_visable_prop = true
      this.show_input_prop = false
      this.show_content_visable_prop = true
      // console.log(this.input_text);
      let sku_id = this.$emit('saveInputContent', this.input_text)
    },
    // 监听改变值
    content_change(content) {
      this.editor_content = content
    },
  },
}
</script>

<style>
.title-and-input {
  border-left: 5px solid #ff5420;
  padding: 0 5px;
}
.title-and-input:hover .input-button-style {
  display: block;
}
.title {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 10px;
}
.edito_save_right {
  /* cursor: pointer; */
}
.input {
  margin-left: 10px;
}

.input-button-style {
  display: none;
  float: right;
  font-size: 10px;
}
.save-button-style {
  float: right;
  font-size: 10px;
}
/* v-bind 绑定两种class */
.class_name_one {
  width: 100px;
}
.class_name_two {
  width: 300px;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>